<template>
  <div class="photo-text">
    <img :src="content.img.filename" alt />
    <vue-markdown class="markdown">{{content.text}}</vue-markdown>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss">
.photo-text {
  display: flex;
  width: $content-width;
  max-width: $max-width;
  margin: auto;
  img {
    margin-right: 10px;
    max-width: 50%;
  }
}
</style>